module.exports = __webpack_public_path__ + "img/icon-time-machine-wait-hover.155fc565.svg";